import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type useMovementsTotalizerProps<T> = {
  filters?: {
    startDate?: string;
    endDate?: string;
    establishmentBranchId?: string;
    fromInternalBase?: string;
  };
  mapper?: (data: any) => T,
};

export const useMovementsTotalizer = <T,>({
  filters: { startDate, endDate, establishmentBranchId, fromInternalBase } = {},
  mapper = Mapper.default<T>(),
}: useMovementsTotalizerProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['productsPrices', startDate, endDate, establishmentBranchId,
      fromInternalBase,],
    queryFn: () => {
      return privateAxios.get('/companies/mine/movements_totalizer', {
        params: {
          'q[created_at_gteq]': startDate,
          'q[created_at_lteq]': endDate,
          'q[establishment_branch_id_eq]': establishmentBranchId,
          'q[from_internal_base_eq]': fromInternalBase,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
